/**
 * Course Detail Page Interactivity
 * Handles tabs, accordion, animations, and other interactive elements
 */

export function initCourseDetailPage() {
  console.log("[v0] Initializing course detail page")

  initLevelTabs()
  initFAQAccordion()
  initScrollAnimations()
  initStatsCounter()
  initVideoPlayer()

  console.log("[v0] Course detail page initialized successfully")
}

/**
 * Initialize level tabs for course levels section
 */
function initLevelTabs() {
  const tabs = document.querySelectorAll(".course-levels__tab")
  const panels = document.querySelectorAll(".course-levels__panel")

  if (!tabs.length || !panels.length) {
    console.log("[v0] Level tabs not found")
    return
  }

  console.log("[v0] Initializing level tabs:", tabs.length, "tabs found")

  tabs.forEach((tab) => {
    tab.addEventListener("click", () => {
      console.log("[v0] Tab clicked:", tab.dataset.level)

      // Remove active class from all tabs
      tabs.forEach((t) => t.classList.remove("course-levels__tab--active"))

      // Add active class to clicked tab
      tab.classList.add("course-levels__tab--active")

      // Hide all panels
      panels.forEach((panel) => panel.classList.remove("course-levels__panel--active"))

      // Show target panel
      const targetLevel = tab.dataset.level
      const targetPanel = document.querySelector(`.course-levels__panel[data-panel="${targetLevel}"]`)

      if (targetPanel) {
        console.log("[v0] Showing panel:", targetLevel)
        targetPanel.classList.add("course-levels__panel--active")
      } else {
        console.log("[v0] Panel not found for level:", targetLevel)
      }
    })
  })
}

/**
 * Initialize FAQ accordion
 */
function initFAQAccordion() {
  const faqItems = document.querySelectorAll(".faq-item")

  if (!faqItems.length) {
    console.log("[v0] FAQ items not found")
    return
  }

  console.log("[v0] Initializing FAQ accordion:", faqItems.length, "items found")

  faqItems.forEach((item) => {
    const question = item.querySelector(".faq-item__question")

    if (question) {
      question.addEventListener("click", () => {
        console.log("[v0] FAQ item clicked")

        // Check if this item is already active
        const isActive = item.classList.contains("active")

        // Close all items
        faqItems.forEach((faqItem) => {
          faqItem.classList.remove("active")
        })

        // If it wasn't active, open it
        if (!isActive) {
          item.classList.add("active")
        }
      })
    }
  })
}

/**
 * Initialize scroll animations
 */
function initScrollAnimations() {
  const animateOnScroll = () => {
    const elements = document.querySelectorAll(
      ".why-feel-free__card, .program-details__feature, .testimonial-card, .pricing-card, .success-story, .teacher-card, .material-card, .learning-path__step",
    )

    elements.forEach((element) => {
      const elementTop = element.getBoundingClientRect().top
      const elementVisible = elementTop < window.innerHeight - 100

      if (elementVisible && !element.classList.contains("animated")) {
        element.classList.add("animated")
        element.style.opacity = "1"
        element.style.transform = "translateY(0)"
      }
    })
  }

  // Initial check
  animateOnScroll()

  // Check on scroll
  window.addEventListener("scroll", animateOnScroll)
}

/**
 * Initialize stats counter animation
 */
function initStatsCounter() {
  const stats = document.querySelectorAll(".course-detail-hero__stat-number")

  if (!stats.length) {
    console.log("[v0] Stats not found")
    return
  }

  console.log("[v0] Initializing stats counter:", stats.length, "stats found")

  function animateStat(stat) {
    const text = stat.textContent.trim()
    const hasPercent = text.includes("%")
    const hasSlash = text.includes("/")

    let target = 0
    let suffix = ""

    if (hasSlash) {
      // Handle "4.9/5" format
      const parts = text.split("/")
      target = Number.parseFloat(parts[0])
      suffix = "/" + parts[1]
    } else {
      // Handle "487" or "93%" format
      target = Number.parseInt(text.replace(/\D/g, ""))
      suffix = hasPercent ? "%" : ""
    }

    let current = 0
    const duration = 2000
    const steps = 60
    const increment = target / steps
    const stepDuration = duration / steps

    const updateStat = () => {
      current += increment
      if (current >= target) {
        if (hasSlash) {
          stat.textContent = target.toFixed(1) + suffix
        } else {
          stat.textContent = Math.floor(target) + suffix
        }
        stat.dataset.animated = "true"
      } else {
        if (hasSlash) {
          stat.textContent = current.toFixed(1) + suffix
        } else {
          stat.textContent = Math.floor(current) + suffix
        }
        setTimeout(updateStat, stepDuration)
      }
    }

    updateStat()
  }

  const observeStats = () => {
    stats.forEach((stat) => {
      if (stat.dataset.animated) return

      const statTop = stat.getBoundingClientRect().top
      if (statTop < window.innerHeight - 100) {
        console.log("[v0] Animating stat:", stat.textContent)
        animateStat(stat)
      }
    })
  }

  observeStats()
  // window.addEventListener("scroll", observeStats)
}

/**
 * Initialize video player
 */
function initVideoPlayer() {
  const playButtons = document.querySelectorAll(".sample-lesson__play-btn")

  if (!playButtons.length) {
    console.log("[v0] Video player not found")
    return
  }

  console.log("[v0] Initializing video player")

  playButtons.forEach((playBtn) => {
    playBtn.addEventListener("click", () => {
      const videoWrapper = playBtn.closest(".sample-lesson__video-wrapper")
      const thumbnail = videoWrapper.querySelector(".sample-lesson__thumbnail")
      const url = playBtn.getAttribute('data-video-url');

      console.log("[v0] Play button clicked", url)

      // Hide thumbnail and play button
      thumbnail.style.display = "none"
      playBtn.style.display = "none"

      // Create and insert video/iframe
      const videoContainer = document.createElement("div")
      videoContainer.className = "sample-lesson__video-container"
      videoContainer.innerHTML = `
      <iframe width="100%" height="100%" src="`+url+`" style="border: none;" allow="clipboard-write; autoplay" webkitAllowFullScreen mozallowfullscreen allowFullScreen></iframe>`

      videoWrapper.appendChild(videoContainer)
    })
  })
}

// Also export individual functions in case they're needed
export { initLevelTabs, initFAQAccordion, initScrollAnimations, initStatsCounter, initVideoPlayer }
